module.exports = __webpack_public_path__ + "media/10.32f5672b.mp3";